// Externe Bibliotheken
import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router';

// Interne Module
import * as storage from '@/_helper/storage';
import { withRouter } from '@/_helper//withRouter';

// Styles
import './footer.scss';

const Footer = () => {
    const [show, setShow] = useState(true);
    const location = useLocation();

    useEffect(() => {
        if (storage.get('mode') !== null && storage.get('mode') === 'app') {
            setShow(false);
        }
    }, []);

    const ch24Footer = () => {
        return (
            <footer className="footer">
                <div className="logo-container">
                    <div className="affiliate-ch24--logo-ch24"></div>
                </div>

                <nav className="footer-bottom-links">
                    <a rel="noopener noreferrer" target="_blank" href="https://urlaub.check24.de/agb">
                        Unsere AGB
                    </a>
                    <a rel="noopener noreferrer" target="_blank" href="https://urlaub.check24.de/datenschutz">
                        Datenschutz
                    </a>
                    <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://www.check24.de/unternehmen/impressum/#comp9">
                        Impressum
                    </a>
                </nav>

                <div className="footer-copyright">
                    <span>
                        © {new Date().getFullYear()} CHECK24 Vergleichsportal Reise GmbH München. Alle Inhalte
                        unterliegen unserem Copyright.
                    </span>
                </div>
            </footer>
        );
    };

    const aurFooter = () => {
        return (
            <footer className="footer">
                <div className="outer-wrapper">
                    <span className="copyright">
                        © {new Date().getFullYear()} AurumTours GmbH. Alle Inhalte unterliegen dem Copyright.
                    </span>

                    <nav className="link-bar no-print">
                        <a rel="noopener noreferrer" href={`${window.$website}/unternehmen/impressum`} target="_blank">
                            Impressum
                        </a>
                        <a rel="noopener noreferrer" href={`${window.$website}/unternehmen/agb`} target="_blank">
                            AGB
                        </a>

                        <NavLink to="/datenschutz" target="_blank">
                            Datenschutz
                        </NavLink>

                        {location?.pathname === '/login' && (
                            <a rel="noopener noreferrer" href={window.$website} target="_blank">
                                www.aurumtours.de
                            </a>
                        )}
                    </nav>
                </div>
            </footer>
        );
    };

    if (show) {
        if (window.$affiliate) {
            switch (window.$affiliate) {
                case 'ch24':
                    return ch24Footer();
                default:
                    return aurFooter();
            }
        } else {
            return aurFooter();
        }
    }
};

export default withRouter(Footer);
